import { useAttrs as useAttrsOriginal } from 'vue';

export const useAttrs = (): Record<string, unknown> => {
  const attrs = {
    ...useAttrsOriginal(),
  };

  delete attrs['data-cy'];
  delete attrs['data-v'];
  return attrs;
};
